// extracted by mini-css-extract-plugin
export var saVideoSliderSection = "saVideoSlider-module--saVideoSliderSection--XrNXX";
export var saBackground = "saVideoSlider-module--saBackground--2YOm3";
export var saIframe = "saVideoSlider-module--saIframe--1lhYn";
export var saTitleContainer = "saVideoSlider-module--saTitleContainer--22Nnh";
export var saSubtitleContainer = "saVideoSlider-module--saSubtitleContainer--kiqgE";
export var saVideoSliderSlider = "saVideoSlider-module--saVideoSliderSlider--39A_G";
export var saVideoSliderListItem = "saVideoSlider-module--saVideoSliderListItem--1nGd3";
export var saVideoSliderListItemImageContainer = "saVideoSlider-module--saVideoSliderListItemImageContainer--hEACU";
export var saVideoSliderListItemContentContainer = "saVideoSlider-module--saVideoSliderListItemContentContainer--2DmXY";
export var saVideoSliderListItemName = "saVideoSlider-module--saVideoSliderListItemName--kDluh";
export var saVideoSliderListItemContent = "saVideoSlider-module--saVideoSliderListItemContent--1lBjt";
export var saVideoSliderListItemPosition = "saVideoSlider-module--saVideoSliderListItemPosition--npUgg";
export var btnPrev = "saVideoSlider-module--btnPrev--34Zm9";
export var btnNext = "saVideoSlider-module--btnNext--3LOru";
export var saVideoSliderBackground = "saVideoSlider-module--saVideoSliderBackground--L_TxG";